<template>
  <div class="page">
    <div class="main-header" :class="{ 'is-first-page': isFirstPage }">
      <div class="container d-flex jc-between">
        <img class="logo" :src="logoImg" @click="onIndex" />
        <img class="logo-mobile" :src="logoMobileImg" @click="onIndex" />
        <div
          class="mode-change d-flex ai-center"
          :class="{ dark: isDark }"
          @click="changeMode"
        >
          <div
            class="mode-btn d-flex ai-center jc-center"
            :class="{ dark: isDark }"
          >
            <img :src="modeImg" />
          </div>
        </div>
      </div>
      <!-- 输入检测地址 -->
      <div class="header-wrap" v-if="!isFirstPage">
        <div
          class="header d-flex ai-center jc-between"
          v-if="isLoading || tokenInfo !== null || isError"
        >
          <div class="left-wrap d-flex ai-center">
            <div class="d-flex ai-center" ref="chainBtn" @click="onChain">
              <img class="chain-icon" :src="chainList[chainIndex].icon" />
              <img v-if="isDark" class="down" src="../assets/down.png" />
              <img v-else class="down" src="../assets/down-black.png" />
            </div>
            <div class="vertical"></div>
            <input
              class="text"
              type="text"
              v-model="address"
              :placeholder="$t('placeholder')"
              @keydown.enter="beginCheck(address, blockchain_id)"
            />
            <img
              class="delete"
              v-show="address"
              @click="onDelete"
              :src="deleteImg"
            />
          </div>
          <div class="text button" @click="beginCheck(address, blockchain_id)">
            {{ $t('detection') }}
          </div>
          <ChainList
            v-show="isMask"
            :chainList="chainList"
            @chooseChain="chooseChain"
            isResult
          />
        </div>
        <!-- <div class="text content desc" v-if="tokenInfo !== null"> -->
        <!-- <div class="text content desc">
          {{ $t('detectionDesc') }}
        </div> -->
        <img class="bg-img" src="../assets/index/index-img.png" alt="" />
      </div>
    </div>
    <div class="index" v-if="isFirstPage">
      <div class="main-container d-flex flex-column ai-center">
        <img class="main-img" src="../assets/index/index-img.png" />
        <div class="chain-wrap d-flex ai-center jc-between" @click="onChain">
          <div class="cur-chain d-flex ai-center">
            <img :src="chainList[chainIndex].icon" />
            <span class="text">{{ chainList[chainIndex].label }}</span>
          </div>
          <img class="down" src="../assets/index/down.png" />
          <ChainList
            v-show="isMask"
            :chainList="chainList"
            @chooseChain="chooseChain"
          />
        </div>
        <div class="input-wrap d-flex ai-center">
          <input
            type="text"
            :placeholder="$t('placeholder')"
            v-model="address"
            @keydown.enter="beginCheck(address, blockchain_id)"
          />
        </div>
        <div class="button text" @click="beginCheck(address, blockchain_id)">
          {{ $t('submit') }}
        </div>
      </div>
    </div>
    <div class="token-detection" v-else>
      <!-- 检测成功结果 -->
      <div class="detection-result" v-if="tokenInfo !== null && !isError">
        <div class="text content desc">
          {{ $t('detectionDesc') }}
        </div>
        <!-- 安全概括 -->
        <div class="content security-overview">
          <div class="d-flex ai-center">
            <div class="report-title">
              <img src="../assets/check-report.png" alt="" />
              <span>{{ $t('securityOverview') }}</span>
            </div>
            <div class="warn-wrap d-flex ai-center jc-between">
              <div class="warn-item d-flex ai-center">
                <img class="red" src="../assets/red.png" />
                <div class="warn-text">
                  <span class="text">{{ $t('risky') }}</span>
                  <span class="text">{{ risky }}</span>
                </div>
              </div>
              <div class="vertical" :class="{ dark: isDark }"></div>
              <div class="warn-item d-flex ai-center">
                <img class="orange" src="../assets/orange.png" />
                <div class="warn-text">
                  <span class="text">{{ $t('attentionTip') }}</span>
                  <span class="text">{{ attention }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="share-report" @click="onShare">
            <img src="../assets/share.png" alt="" />
            <span>{{ $t('share_report') }}</span>
          </div>
        </div>
        <div class="security-overview security-overview-mobile">
          <div class="report-title-mobile">
            <div class="left-title">{{ $t('securityOverview') }}</div>
            <div class="share-report" @click="onShare">
              <img src="../assets/share.png" alt="" />
              <span>{{ $t('share_report') }}</span>
            </div>
          </div>
          <div class="line"></div>
          <div class="warn-wrap d-flex ai-center jc-between">
            <div class="warn-item d-flex ai-center">
              <img class="red" src="../assets/red.png" />
              <div class="warn-text">
                <span class="text">{{ $t('risky') }}</span>
                <span class="text">{{ risky }}</span>
              </div>
            </div>
            <div class="vertical" :class="{ dark: isDark }"></div>
            <div class="warn-item d-flex ai-center">
              <img class="orange" src="../assets/orange.png" />
              <div class="warn-text">
                <span class="text">{{ $t('attentionTip') }}</span>
                <span class="text">{{ attention }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="content-detail">
          <div class="base-trade-contract">
            <!-- 基本信息 -->
            <div class="content base-content">
              <div class="text title">{{ $t('baseInfo') }}</div>
              <div class="line"></div>
              <div class="box">
                <div class="baseInfo firstInfo d-flex ai-center jc-between">
                  <div class="text name">
                    {{ $t('projectSymbol') }}
                  </div>
                  <div
                    class="text word-break flex-1"
                    v-if="tokenInfo.token_symbol"
                  >
                    {{ tokenInfo.token_symbol }}
                  </div>
                  <div class="text word-break flex-1" v-else>~</div>
                </div>
                <div class="baseInfo d-flex ai-center jc-between">
                  <div class="text name">
                    {{ $t('projectName') }}
                  </div>
                  <div
                    class="text word-break flex-1"
                    v-if="tokenInfo.token_name"
                  >
                    {{ tokenInfo.token_name }}
                  </div>
                  <div class="text word-break" v-else>~</div>
                </div>
                <div class="baseInfo d-flex ai-center jc-between">
                  <div class="text name">
                    {{ $t('contractAddress') }}
                  </div>
                  <div class="d-flex ai-center" v-if="tokenInfo.address">
                    <div
                      class="text blue-text"
                      @click="
                        onBlockchainBrowser(tokenInfo.address, chainData.chain_id, blockchain_id, true)
                      "
                    >
                      {{
                        tokenInfo.address.slice(0, 8) +
                        '...' +
                        tokenInfo.address.slice(-8)
                      }}
                    </div>
                    <img
                      class="copy"
                      :src="copyImg"
                      @click="onCopy(tokenInfo.address, true)"
                    />
                  </div>
                  <div class="text word-break" v-else>~</div>
                </div>
                <div class="baseInfo d-flex ai-center jc-between">
                  <div class="text name">
                    {{ $t('contractCreator') }}
                  </div>
                  <div
                    class="d-flex ai-center"
                    v-if="tokenInfo.creator_address"
                  >
                    <div
                      class="text blue-text"
                      @click="
                        onBlockchainBrowser(
                          tokenInfo.creator_address,
                          chainData.chain_id,
                          blockchain_id
                        )
                      "
                    >
                      {{
                        tokenInfo.creator_address.slice(0, 8) +
                        '...' +
                        tokenInfo.creator_address.slice(-8)
                      }}
                    </div>
                    <img
                      class="copy"
                      :src="copyImg"
                      @click="onCopy(tokenInfo.creator_address)"
                    />
                  </div>
                  <div class="text word-break" v-else>~</div>
                </div>
                <div class="baseInfo d-flex ai-center jc-between">
                  <div class="text name">
                    {{ $t('contractOwner') }}
                  </div>
                  <div class="d-flex ai-center" v-if="tokenInfo.owner_address">
                    <div
                      class="text blue-text"
                      @click="
                        onBlockchainBrowser(
                          tokenInfo.owner_address,
                          chainData.chain_id,
                          blockchain_id
                        )
                      "
                    >
                      {{
                        tokenInfo.owner_address.slice(0, 8) +
                        '...' +
                        tokenInfo.owner_address.slice(-8)
                      }}
                    </div>
                    <img
                      class="copy"
                      :src="copyImg"
                      @click="onCopy(tokenInfo.owner_address)"
                    />
                  </div>
                  <div class="text word-break" v-else>~</div>
                </div>
                <div class="baseInfo d-flex ai-center jc-between">
                  <div class="text name">
                    {{ $t('releaseTotal') }}
                  </div>
                  <div
                    class="text word-break flex-1"
                    v-if="tokenInfo.total_supply"
                  >
                    {{ Number(tokenInfo.total_supply).toLocaleString() }}
                  </div>
                  <div v-else class="text word-break">~</div>
                </div>
              </div>
            </div>
            <!-- 交易安全报告 -->
            <div class="content trade-content" v-if="isTrading">
              <div class="text title">{{ $t('tradingSecurityReport') }}</div>
              <div class="line"></div>
              <div class="box">
                <div class="tax-wrap d-flex ai-center jc-between">
                  <div
                    class="tax-button d-flex ai-center jc-between"
                    v-if="tokenInfo.buy_tax"
                  >
                    <span class="text">{{ $t('buy_tax') }}</span>
                    <span class="text" :style="{ background: buyColor }">
                      {{ tokenInfo.buy_tax }}{{ tokenInfo.unknown_buy_tax? '' : '%' }}
                    </span>
                  </div>
                  <div
                    class="tax-button d-flex ai-center jc-between"
                    v-if="tokenInfo.sell_tax"
                  >
                    <span class="text">{{ $t('sell_tax') }}</span>
                    <span class="text" :style="{ background: sellColor }">
                      {{ tokenInfo.sell_tax }}{{ tokenInfo.unknown_sell_tax? '' : '%' }}
                    </span>
                  </div>
                </div>
                <div
                  class="tax-wrap-pc"
                  v-if="tokenInfo.buy_tax || tokenInfo.sell_tax"
                >
                  <div class="d-flex ai-center" v-if="tokenInfo.buy_tax">
                    <span class="text tax-1">{{ $t('buy_tax') }}</span>
                    <span class="text tax-2" :style="{ color: buyColor }">
                      {{ tokenInfo.buy_tax }}{{ tokenInfo.unknown_buy_tax? '' : '%' }}
                    </span>
                  </div>
                  <div class="center"></div>
                  <div class="d-flex ai-center" v-if="tokenInfo.sell_tax">
                    <span class="text tax-1">{{ $t('sell_tax') }}</span>
                    <span class="text tax-2" :style="{ color: sellColor }">
                      {{ tokenInfo.sell_tax }}{{ tokenInfo.unknown_sell_tax? '' : '%' }}
                    </span>
                  </div>
                </div>
                <div class="tradeInfo" v-if="tradeList.length">
                  <InfoItem
                    v-for="(info, index) in tradeList"
                    :key="index"
                    :item="info"
                    @getToastTitle="getToastTitle"
                  />
                </div>
              </div>
            </div>
            <!-- 合约安全报告 -->
            <div class="content trade-content">
              <div class="text title">{{ $t('contractSecurityReport') }}</div>
              <div class="line"></div>
              <div class="contract-ownership" v-if="isHoleAddress">
                {{ $t('contract_ownership') }}
              </div>
              <div class="box">
                <div class="tradeInfo contractInfo" v-if="contractList.length">
                  <InfoItem
                    v-for="(info, index) in contractList"
                    :key="index"
                    :item="info"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="token-lp-holders">
            <!-- token-holders -->
            <div class="content token-holders" v-if="tokenInfo.holders">
              <div class="text title mobile">
                Token Holders ({{ tokenInfo.holder_count }})
              </div>
              <div class="text title pc">Token Holders</div>
              <div class="line"></div>
              <div class="box">
                <div class="top-10 d-flex ai-center jc-between">
                  <div class="holder-number text">
                    <span>Holder number :</span>
                    <span>{{ tokenInfo.holder_count }}</span>
                  </div>
                  <div class="percent-container">
                    <div class="text percent-title">Top 10 holders :</div>
                    <div class="percent-right">
                      <div class="percent-wrap">
                        <div class="percent-value">
                          <div
                            class="value text"
                            :style="{
                              width: holdersPercent.toFixed(2) + '%',
                            }"
                          ></div>
                        </div>
                      </div>
                      <div class="text percent">
                        {{ holdersPercent.toFixed(2) }}%
                      </div>
                    </div>
                  </div>
                </div>
                <div class="userInfo">
                  <UserInfoItem
                    v-for="(tItem, tIndex) in tokenInfo.holders"
                    :key="tIndex"
                    :item="tItem"
                    :index="tIndex"
                    :chain_id="Number(chainData.chain_id)"
                    :blockchain_id="Number(blockchain_id)"
                    @getToastTitle="getToastTitle"
                  />
                </div>
              </div>
            </div>
            <!-- lp-holders -->
            <div
              class="content token-holders lp-holders"
              v-if="tokenInfo.lp_holders"
            >
              <div class="text title mobile">
                LP Holders ({{ tokenInfo.lp_holder_count }})
              </div>
              <div class="text title pc">{{ $t('poolInfo') }}</div>
              <div class="line"></div>
              <div class="box">
                <div class="top-10 d-flex ai-center jc-between">
                  <div class="holder-number text">
                    <span>LP Holders :</span>
                    <span>{{ tokenInfo.lp_holder_count }}</span>
                  </div>
                  <div class="text title title-mobile">Top 10 holders</div>
                  <div class="percent-container">
                    <div class="text percent-title">
                      {{ $t('lockedPercent') }}
                    </div>
                    <div class="percent-right">
                      <div class="percent-wrap">
                        <div class="percent-value">
                          <div
                            class="value text"
                            :style="{
                              width: lockedPercent.toFixed(2) + '%',
                            }"
                          ></div>
                        </div>
                      </div>
                      <div class="text percent">
                        {{ lockedPercent.toFixed(2) }}%
                      </div>
                    </div>
                  </div>
                </div>
                <div class="userInfo">
                  <UserInfoItem
                    lp_holders
                    v-for="(lItem, lIndex) in tokenInfo.lp_holders"
                    :key="lIndex"
                    :index="lIndex"
                    :item="lItem"
                    :chain_id="Number(chainData.chain_id)"
                    :blockchain_id="Number(blockchain_id)"
                    @getToastTitle="getToastTitle"
                  />
                </div>
                <LiquidityPool v-if="ammList.length" :ammList="ammList" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 出错 -->
      <div
        class="text content error-content d-flex flex-column ai-center jc-between"
        v-else-if="isError"
      >
        <template v-if="isContract">
          <img v-if="isDark" src="../assets/error-2-dark.png" />
          <img v-else src="../assets/error-2.png" />
          <span class="text">
            {{ $t('errorContract') }}
          </span>
        </template>
        <template v-else>
          <img v-if="isDark" src="../assets/error-1-dark.png" />
          <img v-else src="../assets/error-1.png" />
          <span class="text">
            {{ $t('errorData') }}
          </span>
        </template>
      </div>
      <div class="go-plus d-flex ai-center jc-center" v-if="!isLoading">
        <a href="https://gopluslabs.io/" class="d-flex">
          <img v-if="isDark" src="../assets/go-plus-dark.png" />
          <img v-else src="../assets/go-plus.png" />
        </a>
      </div>
      <Toast
        v-if="isToast"
        :isCopyContract="isCopyContract"
        :isCopyReportLink="isCopyReportLink"
        :toastTitleObj="toastTitleObj"
        @closeToast="closeToast"
      />
      <div class="loading-img d-flex ai-center jc-center" v-if="isLoading">
        <div class="loading-wrap d-flex flex-column ai-center jc-center">
          <img :src="loadingImg" />
          <span class="text">{{ $t('loading') }}</span>
        </div>
      </div>
    </div>
    <div class="mask-bg" v-show="isMask" @click="onMask"></div>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import InfoItem from '../components/InfoItem.vue';
import UserInfoItem from '../components/UserInfoItem.vue';
import ChainList from '../components/ChainList.vue';
import Toast from '../components/Toast.vue';
import { GlobalMixins } from '../mixins';
import { NodeMap, setMode, CHAIN_INFO_MAP, SERVER_URL } from '../utils';
import LiquidityPool from '../components/LiquidityPool.vue';

const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000';

export default {
  components: { InfoItem, UserInfoItem, Toast, ChainList, LiquidityPool },
  data() {
    return {
      blockchain_id: 1,
      isShowChainList: false,
      isCopyReportLink: false,
      chainIndex: 0,
      isContract: true,
      isMask: false,
      ammList: [],
      hid: undefined,
      swapMarketConfig: {},
      chainData: {
        ns: 'ethereum',
        chain_id: '1',
      },
    };
  },
  mixins: [GlobalMixins],
  computed: {
    ...mapGetters(['isDark']),
    copyImg() {
      let str = '';
      if (this.isDark) {
        str = '-dark';
      }
      return require(`../assets/copy${str}.png`);
    },
    deleteImg() {
      let str = '';
      if (this.isDark) {
        str = '-dark';
      }
      return require(`../assets/delete${str}.png`);
    },
    loadingImg() {
      let str = '';
      if (this.isDark) {
        str = '-dark';
      }
      return require(`../assets/index/loading${str}.png`);
    },
    modeImg() {
      let str = '';
      if (this.isDark) {
        str = '-dark';
      }
      return require(`../assets/index/mode${str}.png`);
    },
    logoImg() {
      let str = '';
      if (this.isDark) {
        str = '-dark';
      }
      if (this.isFirstPage) {
        return require(`../assets/index/index-logo${str}.png`);
      } else {
        return require(`../assets/index/index-logo-dark.png`);
      }
    },
    logoMobileImg() {
      let str = '';
      if (this.isDark) {
        str = '-dark';
      }
      return require(`../assets/index/index-logo${str}.png`);
    },
    queryObj() {
      let obj = {
        address: this.address,
        ns: this.chainData.ns,
        chain_id: this.chainData.chain_id,
      }
      if (this.blockchain_id) {
        obj.blockchain_id = this.blockchain_id
      }
      return obj
    },
    isTrading() {
      if (
        this.tradeList.length ||
        this.tokenInfo.buy_tax ||
        this.tokenInfo.sell_tax
      ) {
        return true;
      } else {
        return false;
      }
    },
    isError() {
      if (this.isDataError || !this.isContract) {
        return true;
      } else {
        return false;
      }
    },
    buyColor() {
      if (this.tokenInfo.buy_tax < 10) {
        if (this.isDark) {
          return '#48B28F';
        } else {
          return '#50C79F';
        }
      } else if (this.tokenInfo.buy_tax >= 10 && this.tokenInfo.buy_tax < 50 || this.tokenInfo.unknown_buy_tax) {
        if (this.isDark) {
          return '#DB671A';
        } else {
          return '#FF7114';
        }
      } else {
        if (this.isDark) {
          return '#EB6055';
        } else {
          return '#C24036';
        }
      }
    },
    sellColor() {
      if (this.tokenInfo.sell_tax < 10) {
        if (this.isDark) {
          return '#48B28F';
        } else {
          return '#50C79F';
        }
      } else if (
        this.tokenInfo.sell_tax >= 10 &&
        this.tokenInfo.sell_tax < 50 ||
        this.tokenInfo.unknown_sell_tax
      ) {
        if (this.isDark) {
          return '#DB671A';
        } else {
          return '#FF7114';
        }
      } else {
        if (this.isDark) {
          return '#EB6055';
        } else {
          return '#C24036';
        }
      }
    },
    isFirstPage() {
      if (this.tokenInfo === null && !this.isError && !this.isLoading) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    queryObj(n) {
      this.$router.replace({
        path: `/`,
        query: { ...n },
      });
    },
  },
  created() {
    document
      .getElementsByTagName('link')[0]
      .setAttribute('href', '/favicon.ico');
    document.title = this.$t('tokenDetectionTitle');
    // console.log('route', this.$route);
    const { address, ns, chain_id, blockchain_id } = this.$route.query;
    if (address && blockchain_id) {
      this.address = address;
      this.blockchain_id = blockchain_id;
      this.chainData.ns = ns;
      this.chainData.chain_id = chain_id;
      this.chainList.forEach((chain, index) => {
        if (chain_id) {
          if (chain.chain_id == chain_id) {
            this.chainIndex = index;
          }
        } else {
          if (chain.blockchain_id == blockchain_id) {
            this.chainIndex = index;
          }
        }
      });
      this.beginCheck(address, blockchain_id);
    } else if (address && ns && chain_id) {
      this.address = address;
      this.chainData.ns = ns;
      this.chainData.chain_id = chain_id;
      this.chainList.forEach((chain, index) => {
        if (chain_id) {
          if (chain.chain_id == chain_id) {
            this.chainIndex = index;
          }
        }
      });
      this.blockchain_id = ''
      this.beginCheck(address);
    } else {
      console.log('no');
    }
  },
  mounted() {
    // 监听，除了点击自己，点击其他地方将自身隐藏
    document.addEventListener('click', this.onOutside);
    document.body.style.overflow = 'auto';
    this.getSwapMarketConfig();
  },
  beforeDestroy() {
    document.removeEventListener('click', this.onOutside);
  },
  methods: {
    onShare() {
      if (!this.isToast) {
        this.isCopyReportLink = true;
        this.isToast = true;
        this.$copyText(window.location.href);
        setTimeout(() => {
          this.isToast = false;
          this.isCopyReportLink = false;
        }, 1000);
      }
    },
    async getPools(base_token, blockchain_id) {
      this.ammList = [];
      const response = await fetch(
        `${SERVER_URL}/v1/swap_market/pools?blockchain_id=${blockchain_id}&base_token=${base_token}`
      );
      const res = await response.json();
      console.log('ammList', res);
      if (res.result === 0 && res.data) {
        const list = res.data || [];
        // const priceScale = list[0] && this.getPriceScale(list[0].price_usd);
        // this.priceScale = priceScale;
        const dexObj = this.swapMarketConfig[blockchain_id].swap_router_map;
        const dexArr = Object.values(dexObj);
        this.ammList = list.map((item) => {
          let arr = dexArr.filter((d) => {
            return d.icon === item.icon;
          });
          let arr1 = [];
          if (this.tokenInfo && Array.isArray(this.tokenInfo.dex)) {
            arr1 = this.tokenInfo.dex.filter((d) => {
              return d.pair === item.pair;
            });
          }
          let name = '';
          if (arr1[0]) {
            name = arr1[0].name;
          } else {
            name = arr[0] && arr[0].name;
          }
          return {
            logo: item.icon,
            pair_address: item.pair,
            name: name,
            // liquidity: arr[0] ? arr[0].liquidity : '',
            pair: {
              symbol0: item.symbol0,
              symbol1: item.symbol1,
              reserve0: this.parseWithUnit(item.reserve0, 'vol'),
              reserve1: this.parseWithUnit(item.reserve1, 'vol'),
            },
            value: this.parseWithUnit(item.market_value, 'vol'),
          };
        });
      }
    },
    async getSwapMarketConfig() {
      try {
        const response = await fetch(
          `${SERVER_URL}/v1/swap_market/config`
        );
        const res = await response.json();
        if (res.result === 0 && res.data) {
          this.swapMarketConfig = res.data;
        }
      } catch (error) {
        console.log('swap_market/config错误', error);
      }
    },
    parseWithUnit(val, type) {
      try {
        if (val >= 1000000000000) {
          return Math.round(val / 1000000000) / 1000 + 'T';
        } else if (val < 1000000000000 && val >= 1000000000) {
          return Math.round(val / 1000000) / 1000 + 'B';
        } else if (val < 1000000000 && val >= 1000000) {
          return Math.round(val / 10000) / 100 + 'M';
        } else if (val < 1000000 && val >= 10000) {
          return Math.round(val / 10) / 100 + 'K';
        } else if (val < 10000 && val >= 1) {
          return val.toFixed(1);
        } else if (val > 0) {
          if (type === 'tvl') {
            return 0;
          } else {
            const arr = val.toString().split('');
            const pointIndex = arr.indexOf('.');
            if (pointIndex >= 0) {
              let firstEfficientIndex = pointIndex;
              for (let i = pointIndex + 1; i < arr.length; i++) {
                if (arr[i] !== '0') {
                  firstEfficientIndex = i;
                  break;
                }
              }
              return arr
                .slice(0, Math.min(firstEfficientIndex + 3, arr.length))
                .join('');
            }
          }
        } else {
          return 0;
        }
      } catch (err) {
        console.log(err, val);
      }
    },
    getPriceScale(val) {
      let priceScale;
      if (val >= 10) {
        priceScale = 100;
      } else if (val < 10 && val >= 1) {
        priceScale = 1000;
      } else if (val < 1 && val >= 0.0001) {
        priceScale = 100;
        while (val < 1) {
          val *= 10;
          priceScale *= 10;
        }
      } else if (val < 0.0001 && val > 0) {
        priceScale = 1000;
        while (val < 1) {
          val *= 10;
          priceScale *= 10;
        }
      } else {
        priceScale = 1000;
      }
      return priceScale;
    },
    onMask() {
      this.isMask = false;
      document.body.style.overflow = 'auto';
    },
    onIndex() {
      this.tokenInfo = null;
      this.isDataError = false;
      this.address = '';
      this.blockchain_id = 1;
      this.chainIndex = 0;
      document.body.style.overflow = 'auto';
    },
    onDelete() {
      this.address = '';
    },
    onChain() {
      this.isMask = true;
      document.body.style.overflow = 'hidden';
    },
    changeMode() {
      let mode = document.documentElement.hasAttribute('theme');
      setMode(!mode);
      this.$store.commit('setDark', !mode);
      if (mode) {
        window.localStorage.setItem('mode', 'light');
      } else {
        window.localStorage.setItem('mode', 'dark');
      }
    },
    getToastTitle(obj) {
      this.toastTitleObj = obj;
      if (!this.isToast) {
        this.isToast = true;
        setTimeout(() => {
          this.isToast = false;
        }, 1500);
      }
    },
    onOutside(e) {
      const chainBtn = this.$refs.chainBtn;
      if (chainBtn && !chainBtn.contains(e.target)) {
        const contentWrap = document.querySelector('.select-chain');
        if (contentWrap && !contentWrap.contains(e.target)) {
          this.isShowChainList = false;
        }
      }
    },

    async beginCheck(address, blockchain_id) {
      this.isMask = false;
      if (this.address !== '') {
        this.isDataError = false;
        await this.tokenSecurity(address, blockchain_id, this.chainData);
        // 只支持 EVM 和已经支持了交易记录的链
        if (blockchain_id) {
          this.getPools(address, blockchain_id);
          if (this.tokenInfo && this.tokenInfo.token_symbol) {
            this.getTokenStatus(address, blockchain_id, this.tokenInfo.token_symbol)
          }
        }
        if (this.tokenInfo && !this.tokenInfo['owner_address']) {
          this.isContract = await this.getCode(
            address,
            NodeMap[this.chainData.chain_id],
            this.chainData.chain_id
          );
        } else {
          this.isContract = true;
        }
      }
    },

    openChainList() {
      this.isShowChainList = true;
    },
    chooseChain(index, blockchain_id, chain_id, ns) {
      document.body.style.overflow = 'auto';
      this.isMask = false;
      this.chainIndex = index;
      this.blockchain_id = blockchain_id;
      this.isShowChainList = false;
      this.chainData.chain_id = chain_id;
      this.chainData.ns = ns;
      this.beginCheck(this.address, this.blockchain_id)
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  background: var(--bg-9);
  min-height: 100vh;
}
.main-header {
  position: relative;
  padding: 0.25rem 0 0.42rem;
  background: var(--bg-11);
  &.is-first-page {
    background: none;
  }
  .container {
    max-width: 12rem;
    margin: 0 auto;
  }
  .logo {
    width: 1.76rem;
    height: 0.24rem;
    cursor: pointer;
  }
  .logo-mobile {
    display: none;
  }
  .mode-change {
    width: 0.58rem;
    height: 0.34rem;
    background: #f6f6f6;
    border: 0.01rem solid #eeeeee;
    border-radius: 0.18rem;
    padding: 0.02rem;
    cursor: pointer;
    &.dark {
      background: #03c288;
      border: 0.01rem solid #03c288;
    }
    .mode-btn {
      width: 0.3rem;
      height: 0.3rem;
      background: #ffffff;
      border-radius: 0.15rem;
      transition: transform 0.5s;
      &.dark {
        transform: translateX(0.22rem);
      }
      img {
        width: 0.16rem;
      }
    }
  }
  .vertical {
    width: 0.01rem;
    height: 0.24rem;
    background: var(--input-border);
  }
  .header-wrap {
    position: relative;
    max-width: 12rem;
    margin: 0 auto;
    margin-top: 0.32rem;
    .header {
      max-width: 7.6rem;
      position: relative;
      z-index: 100;
      .left-wrap {
        flex: 1;
        height: 0.44rem;
        padding: 0 0.15rem 0 0.1rem;
        background: var(--bg-14);
        border-radius: 0.12rem;
        border: 0.01rem solid var(--border-1);
        .chain-icon {
          width: 0.3rem;
          height: 0.3rem;
          cursor: pointer;
        }
        .down {
          margin: 0 0.16rem 0 0.08rem;
          width: 0.14rem;
          cursor: pointer;
        }
        input {
          margin-left: 0.16rem;
          border: none;
          width: 2rem;
          width: 100%;
          font-size: 0.14rem;
          background: var(--chain-list-bg);
          color: var(--gray-10);
        }
        .delete {
          width: 0.14rem;
        }
      }
      .button {
        margin-left: 0.12rem;
        padding: 0 0.25rem;
        height: 0.44rem;
        line-height: 0.44rem;
        background: #2980fe;
        border-radius: 0.12rem;
        font-size: 0.12rem;
        text-align: center;
        color: #ffffff;
        cursor: pointer;
      }
      .select-chain {
        position: absolute;
        top: 0.9rem;
        background: #ffffff;
        border: 0.01rem solid var(--input-border);
        border-radius: 0.1rem;
        box-shadow: 0 0.6rem 1.2rem -0.15rem rgba(192, 192, 192, 0.4);
        padding: 0.32rem 0.32rem 0.48rem;
        &.dark {
          background: #36383d;
          border: 0.01rem solid #242629;
          box-shadow: none;
        }
        .network {
          font-size: 0.24rem;
          &.dark {
            color: #71747a;
          }
        }
      }
    }
    .desc {
      max-width: 7.6rem;
      margin: 0;
      margin-top: 0.16rem;
      width: 100%;
      padding: 0.1rem 0.2rem;
      font-size: 0.12rem;
      font-family: PingFang SC, PingFang SC-Regular;
      background: rgba(255, 113, 20, 0.1);
      border: 0.01rem solid #ff7114;
      border-radius: 0.08rem;
      color: #fff;
      color: #ff7114;
    }
    .bg-img {
      width: 1.98rem;
      height: 1.47rem;
      position: absolute;
      bottom: -0.25rem;
      right: 1.8rem;
    }
  }
}
.index {
  .main-container {
    .main-img {
      width: 3rem;
      margin-top: 0.5rem;
    }
    .chain-wrap {
      position: relative;
      z-index: 100;
      width: 4.4rem;
      padding: 0.1rem 0.18rem 0.1rem 0.1rem;
      background: var(--chain-bg);
      border: 0.01rem solid var(--chain-border);
      border-radius: 0.12rem;
      margin-top: 0.24rem;
      .cur-chain {
        img {
          width: 0.3rem;
        }
        span {
          margin-left: 0.1rem;
          font-size: 0.14rem;
          font-family: PingFangSC, PingFangSC-Medium;
          font-weight: 500;
          color: var(--gray-10);
          line-height: 0.2rem;
        }
      }
      .down {
        width: 0.14rem;
      }
    }
    .input-wrap {
      margin-top: 0.1rem;
      width: 4.4rem;
      height: 0.5rem;
      background: var(--input-bg);
      border: 0.01rem solid var(--input-border);
      border-radius: 0.12rem;
      input {
        width: 100%;
        padding: 0 0.2rem;
        border: none;
        background: var(--input-bg);
        color: var(--gray-10);
      }
      input::-webkit-input-placeholder {
        /* 使用webkit内核的浏览器 */
        font-size: 0.14rem;
        font-family: PingFangSC, PingFangSC-Regular;
        color: var(--placeholder);
      }
      input:-moz-placeholder {
        /* Firefox版本4-18 */
        font-size: 0.14rem;
        font-family: PingFangSC, PingFangSC-Regular;
        color: var(--placeholder);
      }
      input::-moz-placeholder {
        /* Firefox版本19+ */
        font-size: 0.14rem;
        font-family: PingFangSC, PingFangSC-Regular;
        color: var(--placeholder);
      }
    }
    .button {
      margin-top: 0.16rem;
      width: 4.4rem;
      height: 0.5rem;
      line-height: 0.5rem;
      background: var(--btn-bg);
      text-align: center;
      border-radius: 0.12rem;
      font-size: 0.14rem;
      font-family: PingFangSC, PingFangSC-Regular;
      color: #ffffff;
      cursor: pointer;
    }
    .button:hover {
      background: var(--btn-hover);
    }
  }
}
.mask-bg {
  position: absolute;
  z-index: 99;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
}
.token-detection {
  position: relative;
  width: 12rem;
  margin: 0 auto;
  background: var(--bg-9);
  .detection-result {
    .content {
      width: 100%;
      border-radius: 0 0 0.12rem 0.12rem;
    }
    .desc {
      // max-width: 7.6rem;
      margin: 0;
      margin-top: 0.16rem;
      width: 100%;
      padding: 0.1rem 0.2rem;
      font-size: 0.12rem;
      font-family: PingFang SC, PingFang SC-Regular;
      background: rgba(255, 113, 20, 0.1);
      border: 0.01rem solid #ff7114;
      border-radius: 0.08rem;
      color: #fff;
      color: #ff7114;
    }
    .security-overview {
      padding: 0.2rem 0 0.26rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .report-title {
        display: flex;
        align-items: center;
        img {
          width: 0.32rem;
        }
        span {
          margin-left: 0.1rem;
          font-size: 0.22rem;
          font-family: PingFang SC, PingFang SC-Semibold;
          font-weight: 600;
          text-align: left;
          color: var(--gray-10);
        }
      }
      .warn-wrap {
        margin-left: 0.4rem;
        justify-content: flex-start;
        .warn-item {
          &:nth-child(3) {
            margin-left: 0.7rem;
          }
          .warn-text {
            display: flex;
            flex-direction: column;
          }
          img {
            margin-right: 0.12rem;
          }
          .red {
            width: 0.4rem;
          }
          span {
            font-size: 0.12rem;
            font-weight: 400;
            color: var(--gray-10);
            transform: scale(0.9);
          }
          .orange {
            width: 0.4rem;
          }
          span:nth-child(2) {
            font-weight: 500;
            font-size: 0.2rem;
          }
        }
        .vertical {
          display: none;
        }
      }
      .share-report {
        padding: 0.1rem 0.2rem;
        border: 0.01rem solid #2980fe;
        border-radius: 0.19rem;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        img {
          width: 0.16rem;
          height: 0.16rem;
        }
        span {
          margin-left: 0.06rem;
          font-size: 0.12rem;
          font-family: PingFang SC, PingFang SC-Regular;
          color: #2980fe;
        }
      }
    }
    .security-overview-mobile {
      display: none;
    }
    .content-detail {
      display: flex;
    }
    .title {
      padding: 0;
      font-size: 0.16rem;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 500;
      text-align: left;
      color: var(--gray-10);
      line-height: 0.22rem;
      margin-bottom: 0.1rem;
    }
    .box {
      padding: 0 0.2rem 0.2rem;
    }
    .line {
      display: none;
    }
    .base-trade-contract {
      width: 4.78rem;
      .name {
        font-size: 0.12rem;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        color: var(--gray-14);
        min-width: auto;
        line-height: normal;
      }
      .tax-wrap-pc {
        // display: flex;
        display: none;
        align-items: center;
        justify-content: center;
        border: 0.01rem solid var(--input-border);
        border-radius: 0.08rem;
        padding: 0.08rem 0;
        margin-top: 0.1rem;
        .tax-1 {
          font-size: 0.14rem;
          font-family: PingFangSC, PingFangSC-Medium;
          font-weight: 500;
          color: var(--gray-10);
        }
        .tax-2 {
          margin-left: 0.1rem;
          font-size: 0.14rem;
          font-family: PingFangSC, PingFangSC-Medium;
          font-weight: 500;
        }
        .center {
          margin: 0 0.35rem;
          width: 0.01rem;
          height: 0.24rem;
          background: var(--input-border);
        }
      }
    }
    .base-content {
      background: var(--bg-14);
      border: 0.01rem solid var(--border-1);
      border-radius: 0.12rem;
      box-shadow: 0px 6px 20px 0px rgba(0, 0, 0, 0.08);
      .title {
        width: fit-content;
        background: var(--bg-12);
        border-radius: 0px 18px 18px 0px;
        padding: 0.05rem 0.3rem 0.05rem 0.16rem;
        margin: 0.16rem 0 0.18rem;
        line-height: normal;
      }
      .baseInfo {
        margin-top: 0.1rem;
        .word-break {
          margin-left: 0.5rem;
          text-align: right;
          word-break: break-word;
          font-size: 0.14rem;
          font-family: PingFangSC, PingFangSC-Regular;
          font-weight: 400;
          text-align: right;
          color: var(--gray-10);
          line-height: 0.2rem;
        }
        .blue-text {
          width: 1.96rem;
          font-size: 0.14rem;
          font-family: PingFangSC, PingFangSC-Regular;
          font-weight: 400;
          text-align: right;
          color: var(--gray-10);
          line-height: 0.2rem;
        }
        .blue-text:hover {
          text-decoration: underline;
        }
        .copy {
          margin-left: 0.06rem;
          width: 0.14rem;
          height: 0.14rem;
          cursor: pointer;
        }
        .social {
          margin-left: 0.24rem;
          width: 0.32rem;
          height: 0.32rem;
        }
      }
    }
    .trade-content {
      background: var(--bg-14);
      margin-top: 0.2rem;
      border: 0.01rem solid var(--border-1);
      border-radius: 0.12rem;
      box-shadow: 0px 6px 20px 0px rgba(0, 0, 0, 0.08);
      .title {
        width: fit-content;
        background: var(--bg-12);
        border-radius: 0px 18px 18px 0px;
        padding: 0.05rem 0.3rem 0.05rem 0.16rem;
        margin: 0.16rem 0 0.18rem;
        line-height: normal;
      }
      .contract-ownership {
        padding: 0.1rem 0;
        margin: 0 0.2rem 0.2rem;
        background: var(--bg-13);
        border-radius: 0.2rem;
        font-size: 0.14rem;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        text-align: center;
        color: #2980fe;
      }
      .tax-wrap {
        .tax-button {
          border: 0.01rem solid var(--border-1);
          border-radius: 0.4rem;
          width: 48%;
          padding: 0.1rem 0.2rem;
          background: var(--bg-1);
          :nth-child(1) {
            font-size: 0.14rem;
            color: var(--gray-10);
          }
          :nth-child(2) {
            min-width: 0.75rem;
            height: 0.22rem;
            line-height: 0.22rem;
            text-align: center;
            // padding: 0.01rem 0.1rem;
            font-size: 0.14rem;
            color: #fff;
            border-radius: 0.11rem;
          }
        }
      }
      .tradeInfo {
        padding: 0;
        margin-top: 0.12rem;
      }
      .contractInfo {
        margin-top: 0.06rem;
      }
    }
    .token-lp-holders {
      margin-left: 0.2rem;
      flex: 1;
    }
    .token-holders {
      background: var(--bg-14);
      margin-bottom: 0.16rem;
      border: 0.01rem solid var(--border-1);
      border-radius: 0.12rem;
      box-shadow: 0px 6px 20px 0px rgba(0, 0, 0, 0.08);
      .title {
        width: fit-content;
        background: var(--bg-12);
        border-radius: 0 0.18rem 0.18rem 0;
        padding: 0.05rem 0.3rem 0.05rem 0.16rem;
        margin: 0.16rem 0 0.18rem;
        line-height: normal;
      }
      .mobile {
        display: none;
      }
      .pc {
        display: block;
      }
      .top-10 {
        padding: 0;
        margin-top: 0.06rem;
        flex-direction: column;
        align-items: flex-start;
        .holder-number {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          span {
            color: var(--gray-10);
          }
          :nth-child(1) {
            font-size: 0.14rem;
            font-family: PingFangSC, PingFangSC-Regular;
          }
          :nth-child(2) {
            font-size: 0.16rem;
            font-family: PingFangSC, PingFangSC-Medium;
            font-weight: 500;
          }
        }
        .percent-container {
          margin-top: 0.13rem;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .percent-title {
            color: var(--gray-10);
            white-space: nowrap;
            font-size: 0.14rem;
            font-family: PingFang SC, PingFang SC-Medium;
            font-weight: 500;
          }
          .percent-right {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            .percent-wrap {
              padding: 0.02rem;
              width: 2.24rem;
              border-radius: 0.18rem;
              background: var(--bg-13);
              border: 0.01rem solid var(--border-1);
              .percent-value {
                position: relative;
                width: 100%;
                height: 0.3rem;
                .value {
                  position: absolute;
                  left: 0;
                  top: 50%;
                  transform: translateY(-50%);
                  height: 0.3rem;
                  line-height: 0.3rem;
                  background: #2980fe;
                  border-radius: 0.18rem;
                  font-size: 0.12rem;
                  font-family: PingFangSC, PingFangSC-Regular;
                  font-weight: 400;
                  text-align: center;
                  color: #ffffff;
                }
              }
            }
            .percent {
              margin-left: 0.12rem;
              font-size: 0.14rem;
              font-family: PingFang SC, PingFang SC-Medium;
              font-weight: 500;
              color: #2980fe;
            }
          }
        }
        .title {
          margin-top: 0.16rem;
          font-size: 0.12rem;
          font-family: PingFangSC, PingFangSC-Regular;
          color: var(--gray-10);
          line-height: 0.17rem;
          margin-bottom: 0.07rem;
        }
      }
      .userInfo {
        margin-top: 0.2rem;
        padding: 0.04rem 0.16rem 0.16rem;
        background: var(--bg-12);
        border-radius: 0.12rem;
      }
    }
    .lp-holders {
      background: var(--bg-14);
      .title-mobile {
        display: none;
      }
    }
  }
  .error-content {
    position: relative;
    padding: 1.64rem 0;
    margin: 0 auto;
    text-align: center;
    .query-error {
      width: 2.01rem;
      height: 0.79rem;
    }
    img {
      width: 1.14rem;
      height: 0.98rem;
    }
    span {
      margin-top: 0.16rem;
      font-size: 0.14rem;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      text-align: center;
      padding: 0 0.3rem;
      color: var(--gray-13);
    }
  }
  .go-plus {
    margin-top: 0.4rem;
    img {
      width: 3.23rem;
      height: 0.48rem;
    }
  }
  .loading-img {
    background: var(--bg-9);
    padding-top: 1.05rem;
    @keyframes rotate {
      0% {
        transform: rotate(0);
      }
      100% {
        transform: rotate(180deg);
      }
    }
    img {
      width: 0.58rem;
      height: 0.58rem;
      transition: transform 1s linear;
      animation: rotate 1s linear infinite;
    }
    span {
      margin-top: 0.12rem;
      font-size: 0.12rem;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      text-align: center;
      color: var(--gray-13);
    }
  }
}

@media screen and (max-width: 767px) {
  .page {
    // background: var(--bg-1);
  }
  .main-header {
    width: calc(100% - 0.64rem);
    padding: 0.3rem 0 0;
    margin: 0 auto;
    background: none;
    .container {
      max-width: none;
    }
    .logo {
      display: none;
      width: 2.65rem;
      height: 0.36rem;
    }
    .logo-mobile {
      display: block;
      width: 2.65rem;
      height: 0.36rem;
    }
    .mode-change {
      width: 0.81rem;
      height: 0.48rem;
      background: #f6f6f6;
      border: 0.01rem solid #eeeeee;
      border-radius: 0.25rem;
      .mode-btn {
        width: 0.4rem;
        height: 0.4rem;
        border-radius: 0.21rem;
        &.dark {
          transform: translateX(0.33rem);
        }
        img {
          width: 0.24rem;
        }
      }
    }
    .header-wrap {
      .header {
        // margin: 0 0.32rem;
        position: relative;
        .left-wrap {
          flex: 1;
          height: 0.89rem;
          padding: 0 0.24rem;
          background: var(--bg-9);
          border-radius: 0.16rem;
          .chain-icon {
            width: 0.48rem;
            height: 0.48rem;
            cursor: pointer;
          }
          .down {
            margin: 0 0.16rem 0 0.08rem;
            width: 0.2rem;
            cursor: pointer;
          }
          input {
            margin-left: 0.16rem;
            margin-right: 0.1rem;
            border: none;
            width: 2rem;
            width: 100%;
            font-size: 0.26rem;
            background: var(--bg-9);
          }
          .delete {
            width: 0.26rem;
          }
        }
        .button {
          margin-left: 0.24rem;
          padding: 0 0.25rem;
          height: 0.84rem;
          line-height: 0.84rem;
          background: #2980fe;
          border-radius: 0.16rem;
          font-size: 0.28rem;
          text-align: center;
          color: #ffffff;
          cursor: pointer;
        }
        .select-chain {
          position: absolute;
          top: 0.9rem;
          background: #ffffff;
          border: 0.01rem solid #eaeff3;
          border-radius: 0.24rem;
          box-shadow: 0 0.6rem 1.2rem -0.15rem rgba(192, 192, 192, 0.4);
          padding: 0.32rem 0.32rem 0.48rem;
          &.dark {
            background: #36383d;
            border: 0.01rem solid #242629;
            box-shadow: none;
          }
          .network {
            font-size: 0.24rem;
            &.dark {
              color: #71747a;
            }
          }
        }
      }
      .desc {
        border-radius: 0.16rem;
        margin-top: 0.2rem;
        padding: 0.32rem;
        font-size: 0.24rem;
        font-family: PingFang SC, PingFang SC-Regular;
        // background: rgba(255, 113, 20, 1);
        // color: #ff7114;
        // color: #fff;
      }
      .bg-img {
        display: none;
      }
    }
  }
  .index {
    .main-container {
      .main-img {
        width: 5.4rem;
      }
      .chain-wrap {
        width: calc(100% - 0.64rem);
        padding: 0.18rem 0.3rem 0.18rem 0.2rem;
        .cur-chain {
          img {
            width: 0.62rem;
          }
          span {
            font-size: 0.26rem;
          }
        }
        .down {
          width: 0.2rem;
        }
      }
      .input-wrap {
        width: calc(100% - 0.64rem);
        height: 0.98rem;
        input {
          padding: 0 0.3rem;
          font-size: 0.26rem;
        }
        input::-webkit-input-placeholder {
          /* 使用webkit内核的浏览器 */
          font-size: 0.26rem;
        }
        input:-moz-placeholder {
          /* Firefox版本4-18 */
          font-size: 0.26rem;
        }
        input::-moz-placeholder {
          /* Firefox版本19+ */
          font-size: 0.26rem;
        }
      }
      .button {
        width: calc(100% - 0.64rem);
        height: 0.98rem;
        line-height: 0.98rem;
        font-size: 0.26rem;
        // background: #2980fe;
        background: var(--btn-mobile);
      }
      .button:hover {
        background: var(--btn-mobile);
      }
    }
  }
  .token-detection {
    padding: 0 0 1rem;
    width: 100%;
    margin-top: 0.2rem;
    .vertical {
      width: 0.01rem;
      height: 0.24rem;
      background: var(--input-border);
    }
    .detection-result {
      display: block;
      .content {
        width: calc(100% - 0.64rem);
        padding-bottom: 0.32rem;
        border-radius: 0.16rem;
      }
      .desc {
        margin: 0 auto;
        margin-bottom: 0.2rem;
        padding: 0.24rem;
      }
      .security-overview {
        display: none;
        margin-top: 0.24rem;
        margin-bottom: 0;
        &.dark {
          background: #fff;
        }
        .title {
          font-size: 0.28rem;
          margin-bottom: 0;
        }
        .warn-wrap {
          padding: 0.36rem 0.32rem 0;
          .warn-item {
            flex: 1;
            &:nth-child(3) {
              margin-left: 0;
            }
            img {
              margin-right: 0.16rem;
            }
            span {
              font-size: 0.26rem;
            }
            .red {
              width: 0.47rem;
              height: 0.45rem;
            }
            .orange {
              width: 0.45rem;
              height: 0.45rem;
            }
            span:nth-child(2) {
              margin-left: 0.45rem;
              font-size: 0.44rem;
            }
          }
          .vertical {
            // display: block;
            margin: 0 0.35rem;
          }
        }
      }
      .security-overview-mobile {
        display: block;
        margin: 0 0.32rem;
        padding: 0.3rem 0.32rem;
        background: var(--bg-14);
        border: 1px dashed var(--border-1);
        border-radius: 0.16rem;
        box-shadow: 0px 6px 30px 0px rgba(0, 0, 0, 0.08);
        .report-title-mobile {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 0.28rem;
          .left-title {
            font-size: 0.28rem;
            font-family: PingFang SC, PingFang SC-Medium;
            font-weight: 500;
            text-align: left;
            color: var(--gray-10);
          }
          .share-report {
            border: none;
            img {
              width: 0.22rem;
              height: 0.22rem;
            }
            span {
              margin-left: 0.1rem;
              font-size: 0.22rem;
            }
          }
        }
        .warn-wrap {
          padding: 0;
          margin-left: 0;
          margin-top: 0.28rem;
          .warn-item {
            justify-content: center;
            .warn-text {
              flex-direction: row;
              align-items: center;
            }
            span:nth-child(2) {
              margin-left: 0.2rem;
              font-size: 0.44rem;
            }
          }
        }
      }
      .content-detail {
        flex-direction: column;
        margin-top: 0.2rem;
      }
      .base-trade-contract {
        width: auto;
        .name {
          font-size: 0.26rem;
          font-family: PingFangSC, PingFangSC-Regular;
          font-weight: 400;
          min-width: auto;
          line-height: normal;
          min-width: 2rem;
        }
        .tax-wrap {
          display: flex;
        }
        .tax-wrap-pc {
          display: none;
        }
      }
      .title {
        padding: 0.21rem 0 0.21rem 0.32rem;
        font-size: 0.28rem;
        line-height: normal;
        margin-bottom: 0;
      }
      .box {
        padding: 0;
        border: none;
        border-radius: 0.12rem;
      }
      .line {
        display: block;
      }
      .base-content {
        padding: 0.3rem 0.32rem;
        .title {
          background: none;
          padding: 0;
          margin: 0 0 0.28rem;
        }
        .baseInfo {
          padding: 0;
          margin-top: 0.3rem;
          .blue-text {
            width: auto;
            font-size: 0.24rem;
          }
          .word-break {
            font-size: 0.26rem;
            margin-left: 0.5rem;
            text-align: right;
            word-break: break-word;
          }
          .copy {
            margin-left: 0.18rem;
            width: 0.28rem;
            height: 0.28rem;
            cursor: pointer;
          }
          .social {
            margin-left: 0.24rem;
            width: 0.32rem;
            height: 0.32rem;
          }
        }
        .firstInfo {
          margin-top: 0.32rem;
        }
      }
      .trade-content {
        margin-top: 0.2rem;
        padding: 0.3rem 0.32rem;
        .title {
          background: none;
          padding: 0;
          margin: 0 0 0.28rem;
        }
        .contract-ownership {
          padding: 0.18rem 0;
          margin: 0.3rem 0 0.32rem;
          border-radius: 0.4rem;
          font-size: 0.24rem;
        }
        .tax-wrap {
          padding: 0.28rem 0 0.3rem;
          .tax-button {
            padding: 0.12rem 0.12rem 0.12rem 0.3rem;
            :nth-child(1) {
              font-size: 0.24rem;
            }
            :nth-child(2) {
              min-width: 1.2rem;
              height: 0.4rem;
              line-height: 0.4rem;
              font-size: 0.22rem;
              border-radius: 0.3rem;
            }
          }
        }
        .tradeInfo {
          margin: 0;
        }
        .contractInfo {
          margin-top: 0.24rem;
        }
      }
      .token-lp-holders {
        margin-left: 0;
        margin-top: 0.2rem;
      }
      .token-holders {
        padding: 0.3rem 0.32rem;
        margin-bottom: 0.2rem;
        .mobile {
          display: block;
          background: none;
          padding: 0;
          margin: 0 0 0.28rem;
        }
        .pc {
          display: none;
        }
        .box {
          margin-top: 0.3rem;
        }
        .top-10 {
          padding: 0;
          margin-top: 0;
          flex-direction: row;
          align-items: center;
          .holder-number {
            display: none;
          }
          .percent-container {
            .percent-title {
              font-size: 0.24rem;
            }
            .percent-right {
              margin-left: 0;
              .percent-wrap {
                width: 2rem;
                .percent-value {
                  height: 0.28rem;
                  .value {
                    height: 0.28rem;
                    line-height: 0.28rem;
                  }
                }
              }
              .percent {
                background: none;
                padding: 0;
                font-size: 0.24rem;
                margin-left: 0.1rem;
              }
            }
          }
          .percent-border {
            display: none;
          }
          .percent {
            display: block;
            padding: 0 0.3rem;
            background: var(--bg-10);
            border-radius: 0.11rem;
            font-size: 0.24rem;
            text-align: center;
            color: var(--gray-10);
          }
          .title {
            padding: 0;
            margin-top: 0;
            font-size: 0.26rem;
            margin-bottom: 0;
            line-height: normal;
          }
        }
        .userInfo {
          padding: 0;
          background: none;
          margin-top: 0.4rem;
        }
      }
      .lp-holders {
        .userInfo {
          display: block;
        }
        .title-mobile {
          display: none;
        }
        .title-pc {
          display: none;
        }
      }
    }
    .error-content {
      padding: 1.64rem 0;
      margin: 0 auto;
      text-align: center;
      .query-error {
        width: 2.01rem;
        height: 0.79rem;
      }
      img {
        width: 1.14rem;
        height: 0.98rem;
      }
      span {
        margin-top: 0.16rem;
        font-size: 0.28rem;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: center;
        padding: 0 0.3rem;
      }
    }
    .go-plus {
      margin-top: 0.4rem;
      img {
        width: 3.23rem;
        height: 0.48rem;
      }
    }
  }
}
</style>
